import React from 'react';

import { useParams } from 'react-router-dom';

import { Divider } from '@mui/material';

import Box from '@mui/material/Box';

import { CenteredCircularProgress } from 'components/Progress';

import API from 'utils/api';
import { UuidableName } from 'utils/api/types';

import { SimpleEditor } from 'containers/Tiptap/components/tiptap-templates/simple-editor';

import { formatMoment } from 'utils/formatters/timezone';

import WrappedDataError from 'containers/Error/WrappedDataError';

import VatixLogo from 'components/Icons/VatixLogo';

import { Container, ContentContainer, CreatedAt, Header, LogoContainer, Title } from './styles';

const ShareDocument: React.FunctionComponent = (): React.ReactElement => {
  const params = useParams<{ entityType: string; entityId: string; shareId: string }>();

  const [sharedDocument, setSharedDocument] = React.useState<
    | {
        state: 'loading';
      }
    | {
        state: 'loaded';
        data: {
          uuid: string;
          name: string;
          createdAt: string;
          createdBy: UuidableName;
          tiptapToken: string;
          organisation: string;
        };
      }
    | {
        state: 'error';
        error: string;
      }
  >({
    state: 'loading',
  });

  React.useEffect(() => {
    const loadSharedDocument = async (): Promise<void> => {
      try {
        const { data } = await API.entities.loadSharedDocument(params.entityType!, params.entityId!, params.shareId!)();
        setSharedDocument({ state: 'loaded', data });
      } catch (error) {
        setSharedDocument({ state: 'error', error: 'Error loading shared document' });
      }
    };
    loadSharedDocument();
  }, [params.entityType, params.entityId, params.shareId]);

  if (sharedDocument.state === 'loading') {
    return <CenteredCircularProgress />;
  }

  if (sharedDocument.state === 'error') {
    return <WrappedDataError />;
  }

  const {
    data: { name, createdAt, tiptapToken, organisation },
  } = sharedDocument;

  return (
    <>
      <LogoContainer>
        <VatixLogo />
      </LogoContainer>
      <Container>
        <ContentContainer>
          <Header>
            <Title>{name}</Title>
            <Divider sx={{ width: '60%', margin: '10px auto' }} />
            <CreatedAt>
              <b>Created</b> {formatMoment(createdAt)}
            </CreatedAt>
            <Divider sx={{ width: '60%', margin: '10px auto' }} />
          </Header>

          <Box sx={{ width: 'calc(60% + 40px)', margin: '0 auto' }}>
            <SimpleEditor tiptapToken={tiptapToken} organisation={organisation} documentName={name} />
          </Box>
        </ContentContainer>
      </Container>
    </>
  );
};

export default ShareDocument;
